import React, { useLayoutEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation
} from "react-router-dom";
import {
  Home,
  Forums,
  SingleForum,
  SingleUser,
  WatchNow,
  RegisterPage,
  SuccessPrompt,
  LoginPage,
  LiveScores,
  Standings
} from "../pages";

export const Routes = () => {

  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Redirect to="/home" />
        </Route>
        <Route exact path="/forum/:name">
          <SingleForum />
        </Route>
        <Route exact path="/users/:name">
          <SingleUser />
        </Route>
        <Route path="/home">
          <Home />
        </Route>
        <Route path="/forums">
          <Forums />
        </Route>
        <Route path="/watch">
          <WatchNow />
        </Route>
        <Route path="/register-page">
          <RegisterPage />
        </Route>
        <Route path="/success">
          <SuccessPrompt />
        </Route>
        <Route path="/login">
          <LoginPage />
        </Route>
        <Route path="/scores">
          <Home />
        </Route>
        <Route path="/livescores">
          <LiveScores />
        </Route>
        <Route path="/standings">
          <Standings />
        </Route>
        <Route path="/stats">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
};
